export default "__VITE_ASSET__IHVhSZ2$__"